import { STORAGE_KEY } from '@/constants/storage';
import { pushEvent } from '@/services/meta-conversions-api.service';
import { v4 } from 'uuid';

let context;

function getCookie(name) {
    return context?.$cookies?.get(name);
}

function isEnable() {
    return (
        process?.env?.VUE_APP_ENABLE_META_CONVERSIONS_API?.toLowerCase() ===
        'true'
    );
}

function getUserEmail() {
    return context?.$store?.getters['auth/user']?.email;
}

function getUserPhone() {
    return context?.$store?.getters['auth/user']?.phone;
}

function getUserId() {
    return context?.$store?.getters['auth/user']?.id;
}

function getCustomContents(sourceData) {
    return (sourceData.contents || []).map(({ id, quantity, name, price }) => ({
        id,
        quantity,
        itemPrice: price,
        title: name,
    }));
}

function getExtraContents(sourceData) {
    const contents = (sourceData.contents || []).map(
        ({ id, addons, duration, duration_type }) => ({
            id,
            duration,
            durationType: duration_type,
            addons,
        })
    );
    return {
        transactionId: sourceData.transaction_id,
        affiliation: sourceData.affiliation,
        tax: sourceData.tax,
        contents,
    };
}

function prepareEventData(eventName, eventData) {
    return {
        eventId: v4(),
        eventName,
        eventSourceUrl: location.origin + context.$route.fullPath,
        userData: {
            email: getUserEmail(),
            phone: getUserPhone(),
            fbc: getCookie(STORAGE_KEY.FBC),
            fbp: getCookie(STORAGE_KEY.FBP),
            externalIds: [getCookie(STORAGE_KEY.FBETID), getUserId()].filter(
                (id) => !!id
            ),
        },
        customData: {
            contentIds: eventData.content_ids,
            contentName: eventData.content_name,
            contentType: eventData.content_type,
            orderId: eventData.transaction_id,
            currency: eventData.currency,
            value: eventData.value,
            contents: getCustomContents(eventData),
        },
        extraContents: getExtraContents(eventData),
    };
}

export default (app) => {
    context = app;
    return {
        track(eventName, eventData) {
            if (!isEnable()) {
                return;
            }
            const data = prepareEventData(eventName, eventData || {});
            pushEvent(data);
        },
    };
};
